import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PlayerPreviousOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PlayerPreviousOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M20 2 6 10.24V2H4v20h2v-8.24L20 22V2Zm-2 16.5L6.94 12 18 5.5v13.01-.01Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PlayerPreviousOutlined;